import React, {FC} from 'react';
import styled from 'styled-components';

import {buildHoverParentClassName} from '../../../../libs/shared/helpers/src/browser/hoverHelpers';
import {Handler} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {InlineLinkButton} from '../../../../libs/shared/ui/src/components/buttons/inlineLinkButton';
import {TooltipCoordinator} from '../../../../libs/shared/ui/src/components/tooltips/tooltipCoordinator';
import {TooltipOverflowCondition} from '../../../../libs/shared/ui/src/components/tooltips/tooltipOverflowCondition';
import {ellipsis} from '../../../../libs/shared/ui/src/styles/mixins';
import {AccountModel} from '../../../models/api/accountModel';
import {Skeleton} from '../../common/skeleton';
import {ContactCardActionsWrapper} from '../common/contactCardActionsWrapper';
import {ContactCardCopyButton} from '../common/contactCardCopyButton';

/*
 * Props.
 */

interface ContactCardHeaderAccountProps {
  account?: AccountModel;
  isAccountLoading: boolean;
  navigateToAccountFromContactCard: Handler;
}

/*
 * Style.
 */

const StyledAccountWrapperDiv = styled.div`
  position: relative;
  display: flex;
`;

const StyledInlineLinkButton = styled(InlineLinkButton)`
  ${ellipsis()}
`;

const StyledContactCardActionsWrapper = styled(ContactCardActionsWrapper)`
  top: -4px;
`;

/*
 * Component.
 */

export const ContactCardHeaderAccount: FC<ContactCardHeaderAccountProps> = (props) => {
  const {account, isAccountLoading, navigateToAccountFromContactCard} = props;

  if (isAccountLoading) {
    return (
      <StyledAccountWrapperDiv>
        <Skeleton height="16px" width="175px" />
      </StyledAccountWrapperDiv>
    );
  }
  if (!account) {
    return null;
  }

  return (
    <StyledAccountWrapperDiv className={buildHoverParentClassName()}>
      <StyledInlineLinkButton onClick={navigateToAccountFromContactCard}>
        <TooltipCoordinator render={() => account.name} placement="top">
          <TooltipOverflowCondition>{account.name}</TooltipOverflowCondition>
        </TooltipCoordinator>
      </StyledInlineLinkButton>
      <StyledContactCardActionsWrapper>
        <ContactCardCopyButton copyValue={account.name} />
      </StyledContactCardActionsWrapper>
    </StyledAccountWrapperDiv>
  );
};
